
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }
        public Estado: 'cargando' | 'ok' | 'vacio' = 'vacio';

        public Seleccionado: number = -1;
        @Watch( 'Seleccionado' )
        onSeleccionado()
        {


        }



        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar()
        {
            if ( !this.Busqueda )
                return;

            let b = this.Busqueda;
            await Wait( 500 );
            if ( this.Busqueda != b )
                return;

            if ( this.Estado == 'cargando' )
                return;

            this.Estado = 'cargando';
            this.$emit( 'busqueda', this.Busqueda );
            let e = await Articulo.find( { q: this.Busqueda } );
            this.Seleccionado = -1;
            this.Items = e.Items;
            this.Estado = 'ok';
        }

        public Resaltar( x: string )
        {
            return x.toUpperCase().replace( this.Busqueda.toUpperCase(), `<b>${this.Busqueda.toUpperCase()}</b>` );
        }

        public Seleccionar( x: Articulo)
        {
            this.Controlador.ArticuloSeleccionado = x;
            this.Controlador.Vista.Modo = 'articulo';
        }

        private items: Articulo[] = [];
        public get Items(): Articulo[]
        {
            return this.items;
        }

        public set Items( a: Articulo[] )
        {
            this.items = a;
        }


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        mounted()
        {


        }

    }
